import {
  FETCH_CARDS_SUCCESS,
  FETCH_CARDS_ERROR,
  FETCH_CARDS_NEXT_PAGE,
  DELETE_CARD,
  FETCH_CARDS_START_LOADING,
  FETCH_CARDS_FINISH_LOADING,
  DELETE_CARD_HIELOCO,
  ADD_CARD_HIELOCO,
} from '../types/cards';
import cardsService from '../../services/cards';
import { notification } from 'antd';

const DELAY = 500;

export function fetchCards() {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_CARDS_START_LOADING });

      const cards = await cardsService.getAll({ page: 0 });

      dispatch({
        type: FETCH_CARDS_SUCCESS,
        payload: cards,
      });

      setTimeout(() => {
        dispatch({ type: FETCH_CARDS_FINISH_LOADING });
      }, DELAY);
    } catch (error) {
      notification.open({
        type: 'error',
        message: error.message,
        placement: 'bottomRight',
      });
      dispatch({ type: FETCH_CARDS_ERROR, payload: { error } });
    }
  };
}

export function fetchCardsNextPage(currentPage) {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_CARDS_START_LOADING });

      const cards = await cardsService.getAll({ page: currentPage });

      dispatch({
        type: FETCH_CARDS_NEXT_PAGE,
        payload: cards,
      });

      setTimeout(() => {
        dispatch({ type: FETCH_CARDS_FINISH_LOADING });
      }, DELAY);
    } catch (error) {
      dispatch({ type: FETCH_CARDS_ERROR, payload: { error } });
    }
  };
}

export function deleteCard(id) {
  return async (dispatch) => {
    try {
      const res = await cardsService.deleteCard(id);

      dispatch({
        type: DELETE_CARD,
        payload: { id },
      });

      return Promise.resolve({ message: res.message });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function addCardHieloco(card_id, cardHieloco) {
  return {
    type: ADD_CARD_HIELOCO,
    payload: { card_id, cardHieloco },
  };
}
export function deleteCardHieloco(card_id, hieloco_id) {
  return {
    type: DELETE_CARD_HIELOCO,
    payload: { card_id, hieloco_id },
  };
}
